// Subscription API Service for El Bethel Ministries

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

class SubscriptionAPI {
  // Subscribe to newsletter
  async subscribe(email, name = '', subscriptionType = 'general', interests = []) {
    try {
      const response = await fetch(`${API}/subscriptions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          name,
          subscription_type: subscriptionType,
          interests
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error subscribing:', error);
      throw error;
    }
  }

  // Unsubscribe from newsletter
  async unsubscribe(email) {
    try {
      const response = await fetch(`${API}/subscriptions/${email}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error unsubscribing:', error);
      throw error;
    }
  }

  // Get all subscriptions (admin use)
  async getSubscriptions() {
    try {
      const response = await fetch(`${API}/subscriptions`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching subscriptions:', error);
      throw error;
    }
  }
}

// Export singleton instance
export default new SubscriptionAPI();